import { fetchConfig } from '@theme/utilities';

/**
 * "Yes, add now." in the cart shipping note (snippets/c-cart-shipping-note.liquid).
 * Sets the lone one-time Pouch line to data-quantity (2) through the enclosing
 * cart-items-component, which also re-renders every cart section and fires the standard cart
 * events. The 5% and free shipping are automatic discounts on 2+ Pouches (2026-09-24), so no
 * code is applied.
 *
 * Loaded twice on purpose: by that snippet, and by snippets/cart-drawer.liquid (a Roots edit),
 * because the snippet's own tag does not execute when the drawer re-renders after add-to-cart.
 * The customElements guard at the end makes the double load harmless.
 */
class CartBundleOffer extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', this.#apply);
  }

  #apply = async (/** @type {Event} */ event) => {
    const button = /** @type {HTMLButtonElement} */ (event.currentTarget);
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    try {

      const cartItems = /** @type {any} */ (this.closest('cart-items-component') || document.querySelector('cart-items-component'));
      const line = Number(this.dataset.line);
      const quantity = Number(this.dataset.quantity);
      if (cartItems?.updateQuantity) {
        // Awaited: on failure Horizon's handler swallows the error and keeps this button in place.
        await cartItems.updateQuantity({ line, quantity, action: 'change' });
      } else {
        await fetch(Theme.routes.cart_change_url, fetchConfig('json', { body: JSON.stringify({ line, quantity }) }));
        window.location.reload();
      }
    } catch (error) {
      console.error('[c-cart-bundle-offer]', error);
    } finally {
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('c-cart-bundle-offer')) customElements.define('c-cart-bundle-offer', CartBundleOffer);
